import React from 'react';
import { Box, IconButton } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';

interface HeaderLeftProps {
  onToggleSidebar: () => void;
}

const HeaderLeft: React.FC<HeaderLeftProps> = ({ onToggleSidebar }) => {
  return (
    <Box
      sx={{
        position: 'absolute',
        left: { xs: 0, sm: 15 },
      }}
    >
      <IconButton
        color="primary"
        aria-label="open drawer"
        edge="start"
        onClick={onToggleSidebar}
        sx={{
          p: { xs: 0.75, sm: 1.5 },
        }}
      >
        <MenuIcon />
      </IconButton>
    </Box>
  );
};

export default HeaderLeft;
